/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate the future value of your monthly SIP investments. Enter how much you invest each month, your expected annual return and how long you'll invest.`)
};

const es_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima el valor futuro de tus inversiones mensuales en SIP. Ingresa cuánto inviertes cada mes, tu retorno anual esperado y cuánto tiempo invertirás.`)
};

const de_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätzen Sie den zukünftigen Wert Ihrer monatlichen SIP-Investitionen. Geben Sie ein, wie viel Sie jeden Monat investieren, Ihre erwartete jährliche Rendite und wie lange Sie investieren werden.`)
};

const nl_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat de toekomstige waarde van uw maandelijkse SIP-beleggingen. Voer in hoeveel u elke maand belegt, uw verwachte jaarlijkse rendement en hoe lang u wilt beleggen.`)
};

const fr_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez la valeur future de vos investissements SIP mensuels. Entrez votre investissement mensuel, votre rendement annuel attendu et la durée de votre investissement.`)
};

const it_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima il valore futuro dei tuoi investimenti SIP mensili. Inserisci quanto investi ogni mese, il tuo rendimento annuale atteso e per quanto tempo investerai.`)
};

const pt_br2_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o valor futuro de seus investimentos mensais em SIP. Digite quanto você investe a cada mês, seu retorno anual esperado e quanto tempo você vai investir.`)
};

const pt_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime o valor futuro dos seus investimentos SIP mensais. Introduza quanto investe cada mês, o seu retorno anual esperado e durante quanto tempo vai investir.`)
};

const ja_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月次SIP投資の将来価値を推定します。毎月いくら投資するか、期待年率、投資期間を入力してください。`)
};

const zh_sip_hub_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`估算您的月度SIP投资的未来价值。输入您每月投资的金额、预期年回报率以及投资期限。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_hub_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_hub_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_hub_intro", locale)
	if (locale === "en") return en_sip_hub_intro(inputs)
	if (locale === "es") return es_sip_hub_intro(inputs)
	if (locale === "de") return de_sip_hub_intro(inputs)
	if (locale === "nl") return nl_sip_hub_intro(inputs)
	if (locale === "fr") return fr_sip_hub_intro(inputs)
	if (locale === "it") return it_sip_hub_intro(inputs)
	if (locale === "pt-BR") return pt_br2_sip_hub_intro(inputs)
	if (locale === "pt") return pt_sip_hub_intro(inputs)
	if (locale === "ja") return ja_sip_hub_intro(inputs)
	return zh_sip_hub_intro(inputs)
};